import { NewContentLoadedEvent } from '../events/new-content-loaded';
import hasUserProvidedEmail from '../user/has-provided-email';
import { createCookie } from '../cookies';

let hasProvidedEmail: Promise<boolean> | null = null;

function hidePrivacyConsent( consent: HTMLElement ): void {
    const input = consent.querySelector<HTMLInputElement>( 'input[type="checkbox"]' );

    if ( input ) {
        input.required = false;
        input.disabled = true;
    }

    consent.classList.add( 'd-none' );
}

async function init( container: HTMLElement | Document ): Promise<void> {
    const consentFields = container.querySelectorAll<HTMLElement>( '[data-privacy-consent]' );

    if ( consentFields.length === 0 ) {
        return;
    }

    if ( hasProvidedEmail === null ) {
        hasProvidedEmail = hasUserProvidedEmail();
    }

    if ( !await hasProvidedEmail ) {
        return;
    }

    consentFields.forEach( hidePrivacyConsent );
}

export function acceptPrivacyConsent( form: HTMLFormElement ): void {
    const acceptedInput = form.querySelector<HTMLInputElement>( '[data-privacy-consent] input[type="checkbox"]:checked' );

    if ( !acceptedInput ) {
        return;
    }

    hasProvidedEmail = Promise.resolve( true );
    createCookie( 'gdpr', 'true', 365 );

    document.querySelectorAll<HTMLElement>( '[data-privacy-consent]' ).forEach( hidePrivacyConsent );
}

export default function initPrivacyConsent(): void {
    init( document );

    window.addEventListener( 'twc:newcontentloaded', ( event: CustomEvent<NewContentLoadedEvent> ) => {
        init( event.detail && event.detail.container ? event.detail.container : document );
    } );
}
